import { useState } from 'react';
import type { ExecutionRow, RuleSummary } from '../shared/contracts';
import { messageOf, statusLabel } from './api';

export function CopyBox({ value }: { value: string }) {
  const [notice, setNotice] = useState('');
  return <div><div className="copy-box"><code>{value}</code><button onClick={() => {
    void navigator.clipboard.writeText(value).then(() => setNotice('Copied.')).catch(reason => setNotice(`Copy failed: ${messageOf(reason)}`));
  }}>Copy</button></div><small role="status">{notice}</small></div>;
}

export function GuardDetails({ rule }: { rule: RuleSummary }) {
  if (!rule.guards?.length) return null;
  return <section className="panel guard-details"><h2>Managed workflow safeguards</h2>
    <p>The source, matching policy, and external dependencies are managed together. You can change the rule name or pause it here. Duplicating or deleting this rule requires dependency review.</p>
    {rule.guards.map(guard => <details key={guard.kind}><summary>{statusLabel(guard.kind)} safeguards</summary><dl>
      {Object.entries(guard.settings).map(([key, value]) => <div key={key}><dt>{statusLabel(key)}</dt><dd>{value === null ? 'Not set' : String(value)}</dd></div>)}
    </dl></details>)}
  </section>;
}

export function ExecutionList({ rows }: { rows: ExecutionRow[] }) {
  if (!rows.length) return <p className="empty-state">No executions match this view.</p>;
  return <div className="execution-list">{rows.map(item => <article className="execution-card" key={item.id}>
    <div><strong>Ticket #{item.ticket_id}</strong><small>{item.masked_email ?? item.masked_phone ?? 'Identity not retained'}</small></div>
    <div className="execution-outcome"><span className={`status ${item.category === 'success' ? 'active' : item.category === 'failure' || item.category === 'overdue' ? 'problem' : ''}`}>{statusLabel(item.status)}</span>
      <strong>{statusLabel(item.category)}</strong>{item.error_code && <small>{statusLabel(item.error_code)}</small>}</div>
    <time dateTime={item.created_at}>{new Date(item.created_at).toLocaleString()}</time>
    <details><summary>Execution details</summary><dl><div><dt>Execution ID</dt><dd>{item.id}</dd></div><div><dt>Ingress</dt><dd>{statusLabel(item.ingress_type)}</dd></div>
      <div><dt>Rule version</dt><dd>{item.rule_version}</dd></div><div><dt>Verification</dt><dd>{item.verification_status ?? 'Not confirmed'}</dd></div>
      <div><dt>Last updated</dt><dd>{new Date(item.updated_at).toLocaleString()}</dd></div></dl></details>
  </article>)}</div>;
}
